import { logger } from '../../core/metrics';
import { messageMap } from '../createRequest';

export interface IJsonData {
  result: number;
  description: string;
  data: any;
}

export interface IParams {
  [key: string]: any;
}

export interface IRequestOptions {
  pure?: boolean; // 不处理返回值
  camel?: boolean; // 请求参数是否驼峰化
  base?: string; // 请求 baseUrl
  headers?: object; // http headers
  params?: IParams; // querystring 参数
  body?: any; // body data
  method?: string;
  filter?: boolean; // 过滤空参数
  forceHeaders?: any;
  returnData?: boolean; // 直接返回内容不处理
  pathHeader?: boolean;
}

export interface IFetchOptions {
  credentials: RequestInit['credentials'];
  headers: any;
  body?: any;
}

export interface IMutableObject<T = any> {
  [index: string]: T;
}

export class ApiError extends Error {
  originInfo?: { description: string; path: string; logId: string };
  public response: any;
  constructor(info: {
    description: string;
    path: string;
    logId: string;
    response: any;
  }) {
    const { description, path, logId, response } = info;
    super(description);
    logger.warn(
      `[Code非0][状态码]:${response.status},[路径]:${path},[logId]:${logId},des:${description}`,
    );
    this.originInfo = { ...info };
    this.response = response;
  }
}

export class HttpError extends Error {
  originInfo?: {
    status: number;
    description: string;
    path: string;
    logId: string;
  };
  public response: any;
  public status: number;
  constructor(info: {
    status: number;
    description: string;
    path: string;
    logId: string;
    response: any;
  }) {
    const { status, path, logId, response, description } = info;
    super(description || messageMap[status]);
    logger.error(
      `[HTTP错误][状态码]:${response.status}${description},[路径]:${path},[logId]:${logId}`,
    );
    this.originInfo = { ...info };
    this.response = response;
    this.status = status;
  }
}
